<template>
    <div>
        <table>
            <product v-for="(product, key) in products" :order="product" :key="product.id" :customer="customer" :increment="key"></product>
        </table>
    </div>
</template>

<script>
    export default {
        props: [
            'products',
            'customer'
        ],
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/cart/productlijst.vue